import React, {Component, Fragment} from 'react';
import $_ from 'jquery';
import 'jquery-ui/ui/widgets/autocomplete';

import InputText from 'lib/struct/form/InputText';

import styles from './ProductFinderInput.less';

const customAutocompleteItemRender = (ul, item) => {
	const $link = $_('<a>')
		.addClass('ui-corner-all')
		.text(item.label);

	return $_("<li>")
		.prop('role', 'menuitem')
		.addClass('ui-menu-item')
		.addClass('custom-px-4')
		.addClass('custom-py-8')
		.append($link)
		.appendTo(ul);
};

export default class ProductFinderInput extends Component {
	constructor() {
		super();

		this.state = {
			value: '',
			except_ids: [],
		};
	}

	componentDidMount() {
		const autocomplete_params = {
			minLength: 3,
			delay: 300,
			position: {
				my: 'left top',
				at: 'left bottom',
				collision: 'none flip',
				within: '#shop-productgroup-product-edit'
			},
			source: (request, response) => {
				const {except_ids} = this.state;

				$.ajax({
					url: '?plugin=productgroup&action=autocomplete',
					method: 'GET',
					data: {
						term: request.term,
						except_ids: except_ids,
					},
					dataType: 'json',
					error: () => {
						response([]);
					},
					success: (items) => {
						const {excludes = []} = this.props;

						items = items.filter(item => excludes.indexOf(item.id) === -1);

						response(items);
					}
				});
			},
			select: (event, ui) => {
				const {onSelect} = this.props;

				this.setState({
					value: ''
				});
				onSelect(ui.item);
				return false;
			}
		};

		$_(this.input)
			.autocomplete(autocomplete_params)
			.autocomplete("instance")._renderItem = customAutocompleteItemRender;
	}

	render() {
		const {except_ids} = this.props;

		return (
			<Fragment>
				<InputText
					refNode={input => this.input = input}
					value={this.state.value}
					onChange={e => this.setState({
						value: e.target.value,
						except_ids: except_ids,
					})}
					className={styles['input']}
					placeholder='Поиск товаров'
				/>
			</Fragment>
		);
	}
}